import PlaceholderPage from '@/app/pages/PlaceholderPage';
import {
  PubBonusPage,
  PubBuyInPage,
  PubCustomersPage,
  PubDashboardContent,
  PubHistoryPage,
  PubPrizePage,
  PubTournamentsPage,
} from '@/app/features/pub-admin/pages';
import { pubAdminNavItems, type AdminNavItem, type AdminSurfaceConfig } from '@/app/surface';

export const surfaceConfig: AdminSurfaceConfig = {
  surface: 'pub_admin',
  allowedRole: 'staff_admin',
  title: 'Octopus 매장 관리자',
  shortTitle: 'Pub Admin',
  badge: 'PUB',
  loginTitle: '매장 관리자 로그인',
  loginDescription: '바이인, 상금, 보너스, 토너먼트 등 반복 운영 업무를 처리합니다.',
  usernameLabel: '관리자 ID',
  usernamePlaceholder: 'store_admin',
  homePath: '/',
  navItems: pubAdminNavItems,
};

export function getSurfaceRouteElement(item: AdminNavItem, config: AdminSurfaceConfig) {
  switch (item.path) {
    case '/buy-in':
      return <PubBuyInPage />;
    case '/prize':
      return <PubPrizePage />;
    case '/bonus':
      return <PubBonusPage />;
    case '/tournaments':
      return <PubTournamentsPage />;
    case '/customers':
      return <PubCustomersPage />;
    case '/history':
      return <PubHistoryPage />;
    default:
      return <PlaceholderPage item={item} surfaceConfig={config} />;
  }
}

export function getSurfaceDashboardElement() {
  return <PubDashboardContent />;
}
